import { render } from "./PoweredBy.vue?vue&type=template&id=9aaec252&ts=true"
import script from "./PoweredBy.vue?vue&type=script&lang=ts"
export * from "./PoweredBy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__